import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Grid,
  Box,
} from "@mui/material";
import color from "../../Constants/colors";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  gradingCriterion: any | null;
  isLoading: boolean;
};

const GradingCriterionModal = ({
  open,
  onClose,
  gradingCriterion,
  isLoading,
}: Props) => {
  const { t } = useTranslation("gradingCriteria");

  if (isLoading) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    );
  }

  if (!gradingCriterion) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent
        sx={{
          overflowY: "auto",
          padding: "2rem",
          color: color.white,
        }}
      >
        <Box
          component="img"
          src="/commo_logo.png"
          alt="logo"
          sx={{
            position: "absolute",
            top: "20px",
            left: "16px",
            width: "auto",
            height: "50px",
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              sx={{
                color: color.primary_dark,
                mb: 2,
              }}
            >
              {gradingCriterion.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: color.primary_dark,
                fontWeight: "bold",
              }}
            >
              {t("criterion")}
            </Typography>
            <Box
              sx={{
                color: color.primary_dark,
                whiteSpace: "pre-wrap",
                fontSize: "0.95rem",
              }}
            >
              {gradingCriterion.criterion}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: color.accent,
            color: color.white,
            marginBottom: "10px",
            marginTop: "10px",
            marginRight: "10px",
            "&:hover": {
              backgroundColor: color.primary_dark,
              color: color.accent,
            },
          }}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GradingCriterionModal;
